var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-gutters vertical-flex-fit overflow-y-auto" },
    [
      _vm.mortgageTypeOptions.length
        ? _c("div", { staticClass: "section-wrapper w-100" }, [
            _c("div", { staticClass: "card pb-4" }, [
              _c("div", { staticClass: "card-header px-5" }, [
                _c("div", { staticClass: "row align-items-end" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h2", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t("internal-notes.actions.createInternalNote")
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body px-5" }, [
                _c("div", { staticClass: "row align-items-end" }, [
                  _c(
                    "form",
                    {
                      staticClass: "w-100",
                      attrs: { id: "create-note-form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12 p-0 mb-4" },
                        [
                          _c(
                            "h6",
                            {
                              staticClass:
                                "form-title font-sm mb-0 d-inline-block",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("internal-notes.notesCategory")
                                  ) +
                                  ":\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("select-section", {
                            staticClass: "col-md-4 col-5 d-inline-block",
                            attrs: {
                              name: "category",
                              placeholder: _vm.$t("global.words.category"),
                              options: _vm.noteCategoryOptions,
                            },
                            model: {
                              value: _vm.newNote.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.newNote, "category", $$v)
                              },
                              expression: "newNote.category",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "h6",
                            {
                              staticClass:
                                "form-title font-sm mb-0 d-inline-block",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-flow.labels.mortgageType"
                                    )
                                  ) +
                                  ":\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("select-section", {
                            staticClass: "col-md-4 col-5 d-inline-block",
                            attrs: {
                              name: "category",
                              placeholder: _vm.$t("global.words.category"),
                              options: _vm.mortgageTypeOptions,
                            },
                            model: {
                              value: _vm.currentMortgageType,
                              callback: function ($$v) {
                                _vm.currentMortgageType = $$v
                              },
                              expression: "currentMortgageType",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 p-0" }, [
                        _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$tc("global.words.detail", 2)) +
                              ":\n              "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-12 justify-content-center mt-2 mb-4 p-0",
                        },
                        [
                          _c("div", { staticClass: "row no-gutters mb-2" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newNote.note,
                                  expression: "newNote.note",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "note-details",
                                "data-skip-falsy": "true",
                                rows: "3",
                                name: "details",
                              },
                              domProps: { value: _vm.newNote.note },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newNote,
                                    "note",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "d-none",
                                attrs: { for: "note-details" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$tc("global.words.detail", 2))
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row no-gutters align-items-center justify-content-end",
                            },
                            [
                              _c(
                                "button",
                                {
                                  ref: "submitButton",
                                  staticClass: "btn btn-primary btn-sm",
                                  class: { disabled: _vm.disabledSaveButton },
                                  on: { click: _vm.handleSubmit },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("global.words.save")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card pb-4" }, [
              _c("div", { staticClass: "card-header px-5" }, [
                _c("div", { staticClass: "row align-items-end" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h2", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "internal-notes.messages.existingApplicationNotes"
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body px-5" }, [
                _c("div", { staticClass: "row align-items-end" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("application-notes-table", {
                        attrs: { notes: _vm.internalNotes },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "col flex-column text-center" }, [
            _c("div", { staticClass: "card pb-4" }, [
              _c("div", { staticClass: "card-body px-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row align-items-center justify-content-center",
                  },
                  [
                    _c(
                      "no-results",
                      {
                        attrs: {
                          "img-src": require("@Shared/@Assets/img/application-missing.png"),
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "global.messages.youNeedToFillOutMortgageDetailsFirst"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: { click: _vm.goToMortgageDetails },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "internal-notes.actions.clickHereToFillThem"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }